import React, {createContext, PropsWithChildren, useContext} from 'react';
import {ActorRefFrom} from 'xstate';

import {MetadataLayerMachine} from 'samples/plate-maps/metadata-layers/machine/MetadataLayerMachine';

type MetadataLayerActor = ActorRefFrom<typeof MetadataLayerMachine>;

const ScratchPlateMetadataLayerCtx = createContext<MetadataLayerActor | null>(null);

export function useScratchPlateMetadataLayerActor(): MetadataLayerActor {
  const actor = useContext(ScratchPlateMetadataLayerCtx);
  if (actor == null) {
    throw new Error(
      'useScratchPlateMetadataLayerActor must be used within ScratchPlateMetadataLayerProvider'
    );
  }
  return actor;
}

export default function ScratchPlateMetadataLayerProvider({
  actor,
  children,
}: PropsWithChildren<{actor: MetadataLayerActor}>): JSX.Element {
  return (
    <ScratchPlateMetadataLayerCtx.Provider value={actor}>{children}</ScratchPlateMetadataLayerCtx.Provider>
  );
}
